module.exports = __webpack_public_path__ + "static/media/PM121.43d6501e.png";